var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.toastsGroupedByPosition),function(toastGroup,key){return _c('div',{key:key,class:`fixed ${key} w-full z-70`},_vm._l((toastGroup),function(toast){return _c('toast-item',{key:toast.id,attrs:{"toast":toast}})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }